import { plainToInstance } from 'class-transformer';
import { apiClientFactory } from '../../common/clients';
import { getHeaders } from '../../util/http-utils';
import { ViewStoreAvailabilityRow } from './dto/view-store-availability-row.dto';
import { CustomersExportReportDto } from './dto/customers-export-report.dto';
import { ViewCustomersExportRow } from './dto/view-customers-export-row.dto';

const apiClient = apiClientFactory();

/****************************
Reports
****************************/

const resource = 'reports';

export async function getOrdersSelectedForPicking(): Promise<any> {
  const requestUrl = `v1/${resource}/selected-for-picking`;
  const { data } = await apiClient.get(requestUrl, {
    headers: getHeaders(),
  });

  return data;
}

export async function getDeliveryRackLabelsReport(): Promise<any> {
  const requestUrl = `v1/${resource}/delivery-rack-labels`;
  const { data } = await apiClient.get(requestUrl, {
    headers: getHeaders(),
  });

  return data;
}

export async function getOrdersBetweenReport(
  startOrderWeek: string,
  endOrderWeek: string,
): Promise<any[]> {
  const requestUrl = `v1/${resource}/orders/${startOrderWeek}/${endOrderWeek}`;
  const { data } = await apiClient.get(requestUrl, {
    headers: getHeaders(),
  });

  return data;
}

export async function getOrdersDetailsBetweenReport(
  startOrderWeek: string,
  endOrderWeek: string,
): Promise<any[]> {
  const requestUrl = `v1/${resource}/orders-details/${startOrderWeek}/${endOrderWeek}`;
  const { data } = await apiClient.get(requestUrl, {
    headers: getHeaders(),
  });

  return data;
}

export async function getShippedCountsBetweenReport(
  startWeek: string,
  endWeek: string,
): Promise<any[]> {
  const requestUrl = `v1/${resource}/shipped-counts/${startWeek}/${endWeek}`;
  const { data } = await apiClient.get(requestUrl, {
    headers: getHeaders(),
  });

  return data;
}

export async function getSageSalesOrderBetweenReport(
  startWeek: string,
  endWeek: string,
): Promise<any[]> {
  const requestUrl = `v1/${resource}/sage-sales-order/${startWeek}/${endWeek}`;
  const { data } = await apiClient.get(requestUrl, {
    headers: getHeaders(),
  });

  return data;
}

export async function getSageSalesOrderInSelectedForPickingReport(): Promise<
  any[]
> {
  const requestUrl = `v1/${resource}/sage-sales-order-selected-for-picking/`;
  const { data } = await apiClient.get(requestUrl, {
    headers: getHeaders(),
  });

  return data;
}

export async function getVmxOrderData(orderId: string): Promise<any[]> {
  const requestUrl = `v1/${resource}/vmx-order-data/${orderId}`;
  const { data } = await apiClient.get(requestUrl, {
    headers: getHeaders(),
  });

  return data;
}

export async function getStoreAvailability(): Promise<
  ViewStoreAvailabilityRow[]
> {
  const requestUrl = `v1/${resource}/store-availability`;
  const { data } = await apiClient.get(requestUrl, {
    headers: getHeaders(),
  });

  return plainToInstance(ViewStoreAvailabilityRow, data as [], {
    excludeExtraneousValues: true,
  });
}

export async function getStoreAvailabilityBasic(): Promise<
  ViewStoreAvailabilityRow[]
> {
  const requestUrl = `v1/${resource}/store-availability-basic`;
  const { data } = await apiClient.get(requestUrl, {
    headers: getHeaders(),
  });

  return plainToInstance(ViewStoreAvailabilityRow, data as [], {
    excludeExtraneousValues: true,
  });
}

export async function getCustomersExport(
  exportCustomersReportDto: CustomersExportReportDto,
): Promise<ViewCustomersExportRow[]> {
  const { data } = await apiClient.post(
    `v1/${resource}/customers-export`,
    exportCustomersReportDto,
    {
      headers: getHeaders(),
    },
  );

  const result = plainToInstance(ViewCustomersExportRow, data as [], {
    excludeExtraneousValues: true,
    exposeUnsetFields: false,
  });

  // Remove undefined properties from each row
  const cleanedResult = result.map((row) => {
    const cleanedRow = {} as any;
    Object.entries(row).forEach(([key, value]) => {
      if (value !== undefined) {
        cleanedRow[key] = value;
      }
    });
    return cleanedRow as ViewCustomersExportRow;
  });

  return cleanedResult;
}
